import { NumericFacetRange } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './numeric-range-facet.component.hbs';

export class NumericRangeFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'numericRangeFacet';
    protected override defaultHtml = defaultHtml;

    private get range(): NumericFacetRange | undefined {
        if (this.data?.range?.type === 'numeric') {
            return this.data.range;
        }

        return undefined;
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data || !this.range) {
            return '';
        }

        const html = template({
            startValue: Math.floor(this.range.start),
            endValue: Math.ceil(this.range.end),
            minValue: Math.floor(this.range.min),
            maxValue: Math.floor(this.range.max)
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-start]').forEach((e) => {
            e.addEventListener('blur', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                let value = parseFloat(element.value);

                if (isNaN(value)) {
                    value = Math.floor(this.range!.min);

                    element.value = value.toString();
                }

                this.setFacetValue(value, this.range!.end);
            });
        });

        this.shadowRoot?.querySelectorAll('[hawksearch-end]').forEach((e) => {
            e.addEventListener('blur', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                let value = parseFloat(element.value);

                if (isNaN(value)) {
                    value = Math.ceil(this.range!.max);

                    element.value = value.toString();
                }

                this.setFacetValue(this.range!.start, value);
            });
        });
    }

    private setFacetValue(start: number, end: number): void {
        if (start > end) {
            const tempValue = start;

            start = end;
            end = tempValue;
        }

        start = Math.floor(start);
        end = Math.ceil(end);

        if (start === Math.floor(this.range!.start) && end === Math.ceil(this.range!.end)) {
            return;
        }

        searchService.setFacetValue(this.data!.field!, `${start},${end}`);
    }
}
